import { FC } from 'react';

import {
  Avatar,
  TAvatarBackgroundColorIndex,
  AvatarTypes,
} from '@gem/call/Removable/components/Avatar/Avatar';
import { IcHasRaiseHandIcon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';
import { IconView, IconViewSizes } from '@gem/ui-kit';

import styles from './RiseHand.styles.m.css';

interface IRiseHandProps {
  avatarUrl?: string;
  avatarColorIndex: TAvatarBackgroundColorIndex;
  displayName: string;
}

export const RiseHand: FC<IRiseHandProps> = (props) => {
  const { t } = useTranslation();

  const description = t('calls_raise_hand_event_description', { 0: props.displayName });

  return (
    <div className={styles.riseHandContainer}>
      <IconView
        Icon={IcHasRaiseHandIcon}
        size={IconViewSizes.Medium}
        className={styles.riseHandIcon}
      />
      <Avatar
        className={styles.avatar}
        url={props.avatarUrl}
        title={props.displayName}
        backgroundColorIndex={props.avatarColorIndex}
        type={AvatarTypes.Round_05}
      />
      {description}
    </div>
  );
};
